import { DATA_UNAVAILABLE_TEXT } from '../../constants/credit-report-constants';
import { getTitleCase } from '@zg-rentals/formatters';
import { isCollection } from './credit-report-utils';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';

export const getCollections = (creditReport: CreditReportType) => {
  const { fullCreditProfile } = creditReport;

  if (fullCreditProfile?.TradeLine && fullCreditProfile.TradeLine.length) {
    const { TradeLine: tradeLine } = fullCreditProfile;
    const validCollections = tradeLine.filter(isCollection);

    return validCollections.map((collection) => {
      const { BalanceAmount: amount, SubscriberDisplayName: subscriber } = collection;
      return {
        name: subscriber ? getTitleCase(subscriber) : 'name unavailable',
        amount: amount ? amount : DATA_UNAVAILABLE_TEXT,
      };
    });
  }

  return [];
};
